import { render, staticRenderFns } from "./StepThreeSVG.vue?vue&type=template&id=643ef06a"
import script from "./StepThreeSVG.vue?vue&type=script&lang=js"
export * from "./StepThreeSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports